import { IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import ModalContext from '~/context/srp/ModalContext';
import { ListenerEvent, ListenerEventType } from './constants';

type SaveSearchPayload = {};

function isSaveSearchMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, SaveSearchPayload> {
  return message.event === ListenerEvent.SaveSearch;
}

export default function useSaveSearchHandler(): MessageHandler<
  ListenerEventType,
  SaveSearchPayload
> {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { setSaveSearchModalOpen } = useContext(ModalContext);

  return useMemo(
    () =>
      new MessageHandler(isSaveSearchMessage, () => {
        setSaveSearchModalOpen(true, appliedFilters);
      }),
    [appliedFilters, setSaveSearchModalOpen]
  );
}
